import { ca } from '@cian/analytics';

import { ISoprProducts } from '../../utils/tracking/types';

export function trackFavoriteClick(action: string, label: string, products?: ISoprProducts) {
  ca('eventSite', {
    action,
    category: 'favorite',
    label,
    name: 'oldevent',
    useLastProducts: true,
    products,
  });
}
